import isAny from '../../Utils/Any';
import PermissionRoles from '../../../StaticData/Roles/Permission';

const CanViewInternalOnly = (permissions) => (
  permissions && isAny(permissions.permission_roles, PermissionRoles.SYSTEM_CAMPAIGN_SETTINGS)
);

export default CanViewInternalOnly;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/CanViewInternalOnly.tsx